import React from 'react';
import { Moment } from 'moment';
import MagicForm from '../../../../Components/Form/MagicForm';
import { ItemScheme } from '../../../../Components/Form/MagicFormItem';

interface HealthDataFilterFormProps {
	onSubmit: (values: HealthDataFilterFormValues) => void;
	formScheme: ItemScheme[];
	defaultValues: object;
	submitText?: string;
}

export interface HealthDataFilterFormValues {
	from: string | number | Moment;
	to: string | number | Moment;
	view: string;
	source: string[];
	keys: string[];
	type: string;
}

const HealthDataFilterForm: React.FC<HealthDataFilterFormProps> = props => (
	<MagicForm {...props} />
);

export default HealthDataFilterForm;
